"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var utils_1 = require("../../../pages/utils/utils");
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var Dropdown_1 = __importDefault(require("../inputs/Dropdown"));
var OsobaNazevDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n  padding-bottom: 5px;\n"], ["\n  font-weight: bold;\n  padding-bottom: 5px;\n"])));
var SubjektDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 15px;\n"], ["\n  font-size: 15px;\n"])));
var renderOsoba = function (osoba, ico) {
    return (react_1.default.createElement(SubjektDiv, null,
        react_1.default.createElement(OsobaNazevDiv, null, osoba.nazev || utils_1.getJmenoPrijmeni(osoba.jmeno, osoba.prijmeni, osoba.titulPred, osoba.titulZa)),
        ico && react_1.default.createElement("div", null,
            "I\u010CO: ",
            ico)));
};
var mapOsoba = function (osoba) {
    return {
        value: osoba.id,
        label: osoba.nazev || utils_1.getJmenoPrijmeni(osoba.jmeno, osoba.prijmeni, osoba.titulPred, osoba.titulZa),
        render: renderOsoba(osoba, osoba.ico),
    };
};
var SelectPosudekOsoba = function (_a) {
    var _b;
    var name = _a.name, roleOsob = _a.roleOsob, label = _a.label, placeholder = _a.placeholder, defaultOption = _a.defaultOption, disabled = _a.disabled;
    var _c = formik_1.useField(name), field = _c[0], helpers = _c[2];
    var isLoading = __1.useBoolean();
    var posudkyUrl = __1.useConfig().posudkyUrl;
    var getJSON = __1.useGetJSON(posudkyUrl + "/OsobaSeek");
    var _d = react_1.useState(), options = _d[0], setOptions = _d[1];
    var changedDefault = __1.useBoolean(false);
    var loadOptions = function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchText) return [3 /*break*/, 2];
                    isLoading.setTrue();
                    params = {
                        keyword: searchText,
                        idRole: roleOsob,
                    };
                    return [4 /*yield*/, getJSON(params)];
                case 1:
                    response = _a.sent();
                    isLoading.setFalse();
                    if (__1.isRight(response)) {
                        setOptions(response.value);
                        return [2 /*return*/, response.value.map(function (sub) { return mapOsoba(sub); })];
                    }
                    _a.label = 2;
                case 2:
                    if (changedDefault.value)
                        return [2 /*return*/, []];
                    return [2 /*return*/, (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.option) ? [__assign(__assign({}, defaultOption.option), { render: renderOsoba(defaultOption.option.label, defaultOption.option.ico) })] : []];
            }
        });
    }); };
    return (react_1.default.createElement(components_1.Field, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(Dropdown_1.default, { isSearchable: true, name: "idOsoby", value: (_b = field.value) === null || _b === void 0 ? void 0 : _b.value, placeholder: placeholder, loadOptions: function (search) { return Promise.resolve(loadOptions(search)); }, onChange: function (val) {
                var _a;
                if (((_a = field.value) === null || _a === void 0 ? void 0 : _a.value) !== val)
                    changedDefault.setTrue();
                var op = options === null || options === void 0 ? void 0 : options.find(function (o) { return o.id === val; });
                if (op)
                    return helpers.setValue({ value: val, label: op.jmenoNazev, ico: op.ico, idOsoba: op.idOsoba });
                var defOp = defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.option;
                if ((defOp === null || defOp === void 0 ? void 0 : defOp.value) && val === defOp.value) {
                    return helpers.setValue({ value: defOp.value, label: defOp.label, ico: defOp.ico, idOsoba: defOp.idOsoba });
                }
                helpers.setValue({ value: val });
            }, loading: isLoading.value, defaultOption: defaultOption, enableReset: true, disabled: disabled, rightIcon: disabled ? react_1.default.createElement("span", null) : undefined })));
};
SelectPosudekOsoba.defaultProps = {
    label: undefined,
    placeholder: undefined,
    defaultOption: undefined,
    disabled: false,
};
exports.default = SelectPosudekOsoba;
var templateObject_1, templateObject_2;
